import React from 'react'
import ReactDOM from 'react-dom'
import AnnotationOverlay from './AnnotationOverlay'
import ArticleAnnotation from './ArticleAnnotation'
import CommentAnnotation from './CommentAnnotation'
import RemovePagesAnnotation from './RemovePagesAnnotation'
import PhotoAnnotation from './PhotoAnnotation'
import PubAnnotations from './PubAnnotations'

class PubAnnotationOverlay extends React.Component {
  constructor(props) {
    super(props)

    this.state = {step: 'new', type: this.props.annotation.simple_type || 'Comment'};
    if (this.props.annotation.id != null) {
      this.state.step = 'show';
    }
    this.handleTypeSelect = this.handleTypeSelect.bind(this)
  }

  isAPubIssue(){
    return ["Annotation::PubIssue", "Annotation::CsrNote"].includes(this.props.annotation.type);
  }

  handleTypeSelect(e) {
    e.preventDefault();
    const type = $(e.target).data('label')
    let at = this.props.annotationTypes.find((t) => t.label == type)
    let step = '';
    if (at.label == 'Comment'){
      step = 'new'
    } else {
      step = 'intro';
    }
    this.props.annotation.type = at.class;
    this.props.annotation.type_label = at.label;
    this.setState({type: type, step: step})
  }

  addFirstMessage(id){
    return {
      id: id,
      role_type: "area_director",
      role_name: "Area Director",
      commented_at: this.props.annotation.created_at
    }
  }

  addPhotoMessages(url){
    return {
      id: url,
      role_type: "designer",
      role_name: "Designer",
      commented_at: this.props.annotation.created_at,
      attachment: url
    }
  }

  componentDidMount() {
    if (this.props.klass.showAnnotationOnLoadId){
      $('body').scrollTop($(ReactDOM.findDOMNode(this).children[0]).offset().top)
      this.props.klass.showAnnotationOnLoadId = null
    }
  }

  /*
   * Note this ends up rerendering the overlay twice after removing pages
   * we need to update the state to render a new overlay but we also need to re
   * render the popup from the ajax cb on annotations.jsx#291
   */
  componentDidUpdate(){
    if (this.props.annotation.id != null && this.state.step != 'show') {
      this.setState({step: 'show', type: this.props.annotation.simple_type})
    }
  }

  /*
   * Used to set the first message on annotations like AddFiles and RemovePages
   */
  setFirstAnnotationMessage(){
    if (this.noFirstMessage(this.state.type)) {
      this.props.annotation.messages.unshift(this.addFirstMessage(this.state.type))
    }
  }

  /*
   * Prevents duplicate messages from being appended since we're looking
   * at a dynamic view
   */
  noFirstMessage(str) {
    return !this.props.annotation.messages[0] || !this.props.annotation.messages[0].id.toString().includes(str)
  }

  /*
   * Pub Designers can set annotations before a pdf proof can exist. Their UI for creating
   * these messages is a little different and they can add assets to the annotation. In this case
   * we want to set the photos inline rather than taking the user to another view.
   *
   * This method fakes the asset as a message attachment
   */
  setPhotoMessages() {
    $.each(this.props.annotation.photos, (key, url) => {
      if (!this.messageIsDisplayed(url)) {
        this.props.annotation.messages.splice(key + 1, 0, this.addPhotoMessages(url))
      }
    });
  }

  messageIsDisplayed(id) {
    return $.grep(this.props.annotation.messages, (m) => { return m.id == id; })[0];
  }

  render() {
    let annotation = this.props.annotation;
    let overlayContent;

    switch (this.state.step) {
      case 'new':
        if (this.state.type == 'Comment') {
          overlayContent = <CommentAnnotation klass={this.props.klass} onSelect={this.handleTypeSelect} id={this.props.number} annotation={annotation} roleType={this.props.roleType} annotationTypes={this.props.annotationTypes}/>
        }
        break;

      case 'intro':
        if (this.state.type == 'Photo') {
          overlayContent = <PhotoAnnotation onSelect={this.handleTypeSelect} id={this.props.number} annotation={annotation} roleType={this.props.roleType} annotationTypes={this.props.annotationTypes} />

        } else if (this.state.type == 'Article') {
          overlayContent = <ArticleAnnotation articleOptions={PubAnnotations.init().lateArticleOptions} onSelect={this.handleTypeSelect} id={this.props.number} annotation={annotation} roleType={this.props.roleType} annotationTypes={this.props.annotationTypes} />

        } else if (this.state.type == 'Remove Pages') {
          overlayContent = <RemovePagesAnnotation onSelect={this.handleTypeSelect} id={this.props.number} annotation={annotation} roleType={this.props.roleType} annotationTypes={this.props.annotationTypes} pagesPerSheet={this.props.pagesPerSheet} />

        } else {
          overlayContent = <p>{this.state.type} Annotation Here</p>
        }
        break;

      default:
        if (this.isAPubIssue() && annotation.photos.length) {
          this.setPhotoMessages()
          overlayContent = <CommentAnnotation klass={this.props.klass} id={this.props.number} annotation={annotation} readOnly={this.props.readOnly} limit={1000} roleType={this.props.roleType} annotationTypes={this.props.annotationTypes} />
        } else if (this.state.type == 'comment' || this.state.type == 'csr_note') {
          overlayContent = <CommentAnnotation klass={this.props.klass} onSelect={this.handleTypeSelect} id={this.props.number} annotation={annotation} limit={1000} readOnly={this.props.readOnly} roleType={this.props.roleType} annotationTypes={this.props.annotationTypes} />

        } else if (this.state.type == 'add_photo' ||
          this.state.type == 'remove_pages' ||
          this.state.type == 'add_article' ||
          this.state.type == 'remove_article' ||
          this.state.type == 'remove_photo') {
          this.setFirstAnnotationMessage()
          overlayContent = <CommentAnnotation klass={this.props.klass} id={this.props.number} annotation={annotation} readOnly={this.props.readOnly} limit={1000} roleType={this.props.roleType} annotationTypes={this.props.annotationTypes} />

        } else {
          overlayContent = <p>{this.state.type} Annotation Here</p>
        }
        break;
    }

    return (
      <AnnotationOverlay
        popoverId={this.props.number}
        annotation={annotation}
        overlayContent={overlayContent}
        annotationId={this.props.number}
        roleType={this.props.roleType}
        />
    );
  }
}

export default PubAnnotationOverlay
